export default "__VITE_ASSET__DC$TJybi__"